var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCometsLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 330,
    viewBox: "0 0 396 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -30.001 263.438)",
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 21.1811,
    rx: 10.5906,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -2.27637 157.163)",
    fill: "url(#paint1_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -7.00098 399.438)",
    fill: "url(#paint2_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 429.358,
    height: 7.80083,
    rx: 3.90041,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -33.417 309.118)",
    fill: "url(#paint3_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 375.712,
    height: 2.88812,
    rx: 1.44406,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -99.958 404.711)",
    fill: "url(#paint4_linear)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 258.998 399.438)",
    fill: "url(#paint5_linear)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 154.999 389.438)",
    fill: "url(#paint6_linear)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 264.858,
    height: 7.97029,
    rx: 3.98514,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 179.382 321.821)",
    fill: "url(#paint7_linear)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 111.159,
    height: 14.4998,
    rx: 7.24992,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 212.583 215.854)",
    fill: "url(#paint8_linear)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 192.595,
    height: 21.4892,
    rx: 10.7446,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 96.9414 378.381)",
    fill: "url(#paint9_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 201.081,
    y1: 7.24979,
    x2: -8.18945,
    y2: 7.24976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 201.081,
    y1: 10.5904,
    x2: -8.18945,
    y2: 10.5903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 201.081,
    y1: 7.24979,
    x2: -8.18945,
    y2: 7.24976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 448.275,
    y1: 3.90034,
    x2: -18.2569,
    y2: 3.90012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 392.265,
    y1: 1.44404,
    x2: -15.9758,
    y2: 1.44358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 201.081,
    y1: 7.24979,
    x2: -8.18945,
    y2: 7.24976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5690D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 201.081,
    y1: 7.24979,
    x2: -8.18945,
    y2: 7.24976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 276.527,
    y1: 3.98507,
    x2: -11.2622,
    y2: 3.98499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 116.056,
    y1: 7.24979,
    x2: -4.72664,
    y2: 7.24978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0079FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 201.081,
    y1: 10.7444,
    x2: -8.18945,
    y2: 10.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582CA",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCometsLeft);
export default __webpack_public_path__ + "static/media/CometsLeft.408bdde4390d4cff7f828837f21d656e.svg";
export { ForwardRef as ReactComponent };